export default {"src":"/_next/static/media/location.77c3b6ea.svg","height":13,"width":9,"blurWidth":0,"blurHeight":0};